import { Box, FormLabel, Grid, Typography } from "@mui/material"
import { useFormik } from 'formik';
import { validationsUserInfoSchema } from "../../../validations/validationSignUpSchema";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import BaseColorText from "../../BaseColorText";
import BaseButton from "../../BaseButton";
import BaseInput from "../../BaseInput";
import HelpText from "../../HelpText";
import { formatPhoneNumber } from "../../../hooks/use-format-phone-number";

/**
 * @param {Object} props
 */
const UserInfoForm = ({ onNextStep, setInfoFormStates }) => {

  const { errors, handleBlur, handleChange, handleSubmit, touched, values, setValues } =
    useFormik({
      validateOnBlur: true,
      initialValues: {
        firstName: '',
        lastName: '',
        phone: '',
        npi: '',
      },
      validationSchema: validationsUserInfoSchema,
      onSubmit: (values, { setSubmitting }) => {
        setInfoFormStates(values)
        onNextStep()
      },
    });

  const handleChangePhone = (e) => {
    const value = formatPhoneNumber(e.target.value)
    setValues({
      ...values,
      phone: value
    })
  }

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%'
    }}>
      <Box sx={{
        width: '100%',
        mt: '70px'
      }}>
        <Typography variant="h1">
          More <BaseColorText isGradient gradientColor='#5A3BC7 30%, #5FB2EC 90%'>about you.</BaseColorText>
        </Typography>
        <Typography
          variant="h4"
          sx={{
            color: '#46545F',
            mt: '20px'
          }}
        >
          This tool is strictly for dDNA Physicians and Administrators only.
        </Typography>
        <Box sx={{
          mt: '30px',
        }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={'16px'}>
              <Grid item xs={12} md={6}>
                <BaseInput
                  fullWidth
                  label='First name'
                  name='firstName'
                  type='text'
                  placeholder='First name'
                  value={values.firstName || ''}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={touched.firstName ? errors.firstName : ""}
                  error={touched.firstName && Boolean(errors.firstName)}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <BaseInput
                  fullWidth
                  label='Last name'
                  name='lastName'
                  type='text'
                  placeholder='Last name'
                  value={values.lastName || ''}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={touched.lastName ? errors.lastName : ""}
                  error={touched.lastName && Boolean(errors.lastName)}
                  required
                />
              </Grid>
            </Grid>
            <BaseInput
              sx={{
                mt: '16px',
              }}
              fullWidth
              label='Your phone number'
              name='phone'
              type='text'
              placeholder='Phone'
              value={values.phone || ''}
              onChange={handleChangePhone}
              onBlur={handleBlur}
              helperText={touched.phone ? errors.phone : ""}
              error={touched.phone && Boolean(errors.phone)}
              required
            />
            <Box
              sx={{
                mt: '16px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <FormLabel
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    mb: '1px',
                    color: '#46545F'
                  }}
                  htmlFor='npi'
                >
                  NPI <BaseColorText color='#E73E3E'>*</BaseColorText>
                </FormLabel>
                <HelpOutlineOutlinedIcon 
                  sx={{
                    color: 'primary.mainBlue',
                    fontSize: '18px'
                  }}
                />
              </Box>
              <BaseInput
                fullWidth
                name='npi'
                type='text'
                placeholder='NPI'
                value={values.npi || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={touched.npi ? errors.npi : ""}
                error={touched.npi && Boolean(errors.npi)}
                required
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: { xs: '30px', sm: '50px' },
              }}
            >
              <BaseButton
                disabled={Object.entries(errors).length !== 0}
                variant='contained'
                buttonType='primary'
                type='submit'
              >
                <Typography variant="body">
                  Continue
                </Typography>
                <ChevronRightIcon/>
              </BaseButton>
            </Box>
          </form>
        </Box>
      </Box>
      <HelpText sx={{
        width: '100%',
        borderTop: '1px solid #ABB7C0',
        textAlign: 'center',
        pt: '33px',
        pb: { xs: 0, md: '30px' },
        mt: '80px'
      }} />
    </Box>
  )
}

export default UserInfoForm;